export default {
  loading: 'Indlæser priser…',
  default_modal: {
    title: 'Standardprisliste',
    description:
      'De reserveprisen, som alle partnere uden egen tilpasning arver. Ændringer påvirker aldrig igangværende licenser.',
    saved: 'Standardprislisten er gemt.',
  },
  buttons: {
    edit: 'Rediger',
    cancel: 'Annuller',
    save: 'Gem',
  },
  toasts: {
    load_error: 'Prisdataene kunne ikke indlæses.',
    save_error: 'Kunne ikke gemme – prøv igen.',
    prices_saved: 'Prislisten er gemt.',
    license_created: 'Licens oprettet.',
    lifecycle: {
      pause: 'Licens sat på pause.',
      resume: 'Licens genoptaget.',
      cancel: 'Licens annulleret.',
    },
  },
  price_book: {
    title: 'Prisliste',
    read_only_notice:
      'Partnerpriser tilsidesætter hovedstandardlisten. Igangværende licenser beholder deres låste priser.',
    editing_notice: 'Redigerer – nye priser gælder kun for licenser, der oprettes fra nu af.',
    columns: {
      service: 'Tjeneste',
      cost_price: 'Bruttopris ({{currency}}/måned, inkl. moms)',
    },
    add_ons: 'Tilkøb',
    missing_price: '{{name}} er aktiveret, men har ingen pris – angiv en, eller deaktiver den.',
    incomplete_tier:
      '{{name}} kræver både en mængdepris og antallet af aktive lokationer, den gælder fra, eller ingen af delene.',
    invalid_tier: 'Mængdeprisen for {{name}} skal være under standardprisen, fra mindst 2 aktive lokationer.',
    tier: {
      from: 'Mængdepris fra',
      live_locations: 'aktive lokationer',
      counted_one: 'Denne partner har {{count}} aktiv licenseret lokation, der tæller med i mængderabatten.',
      counted_other: 'Denne partner tæller {{count}} aktive licenserede lokationer mod mængdeprisen.',
    },
    snapshot_note:
      'Priserne låses på en licens, når den oprettes – ændringer i listen påvirker aldrig igangværende licenser.',
    types: {
      base: 'Basis',
      add_on: 'Tilkøb',
    },
  },
  volume_discount: {
    title: 'Mængderabat',
    read_only_notice:
      'Når en månedlig faktura omfatter det antal licenser, der er tærsklen, fratrækkes rabatten alle licensgebyrer i den periode.',
    editing_notice: 'Redigerer – de nye indstillinger gælder fra næste faktureringsperiode.',
    threshold_label: 'Licenstærskel',
    percent_label: 'Rabat',
    invalid: 'Angiv en tærskel på mindst 1 og en rabat mellem 0 og 100 %.',
    saved: 'Mængderabat gemt.',
    note: 'Tæller licenser, der faktureres i selve perioden; overførte måneder er udeladt. 0 % (standard) deaktiverer rabatten – ellers ville den blive lagt oven i mængdeprisen i prislisten.',
  },
  licenses: {
    test_restaurant_unlicensable: 'En testrestaurant faktureres aldrig og kan derfor ikke have en licens.',
    title: 'Restaurantlicenser',
    select_company: 'Vælg en restaurant',
    add_license: 'Tilføj licens',
    no_companies: 'Denne partner har endnu ingen restauranter.',
    no_licenses: 'Ingen licenser til denne restaurant endnu.',
    activated_at: 'Aktiv siden',
    next_period_preview: 'Næste måned (forholdsmæssigt, før mængderabat)',
    statuses: {
      active: 'Aktiv',
      paused: 'På pause',
      canceled: 'Annulleret',
    },
    columns: {
      product: 'Tjeneste',
      locked_price: 'Låst pris / måned',
      quantity: 'Antal',
      trial_ends: 'Gratis indtil',
    },
    price_tiers: {
      volume: 'Mængderabat',
      locked: 'Ældre pris',
    },
  },
  lifecycle: {
    pause: {
      action: 'Sæt på pause',
      title: 'Sæt denne licens på pause?',
      description:
        'Dage på pause faktureres ikke. Licensen beholder sine låste priser og kan genoptages når som helst.',
      confirm: 'Sæt på pause',
    },
    resume: {
      action: 'Genoptag',
      title: 'Genoptag denne licens?',
      description: 'Faktureringen fortsætter fra i dag til de låste priser.',
      confirm: 'Genoptag',
    },
    cancel: {
      action: 'Annuller licens',
      title: 'Annuller denne licens?',
      description:
        'Den nuværende måned faktureres forholdsmæssigt frem til i dag. Dette kan ikke fortrydes – der oprettes en ny licens til de aktuelle listepriser.',
      confirm: 'Annuller licens',
    },
  },
  add_license: {
    title: 'Tilføj en licens',
    description: 'Vælg tjenesterne til denne restaurant. Priserne låses på licensen ved oprettelsen.',
    per_month: ' / måned',
    create: 'Opret licens',
    no_priced_products: 'Ingen produkter har endnu en brugbar pris for denne partner – angiv først prislisten.',
  },
};
